import { useState } from 'react';
import { breakpoints, Button, Dialog, Inline, Stack, Text, textVariants } from '@etg/wings';
import { Info } from '@phosphor-icons/react';
import { css, cx } from '@eti/styles';
import { useTranslation } from '@eti/providers';
import { price as priceUtil } from '@eti/utils';
import { useSeatCharacteristicDisplay } from '../../hooks/useSeatCharacteristicDisplay';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const iconStyles = css`
  height: 24px;
  width: 24px;
`;
const priceDescriptionStyles = css`
  width: 75%;
`;
const wrapperStyles = css`
  width: 100%;
`;
const buttonStyles = {
  base: css`
    bottom: 72px;
    cursor: pointer;
    height: 34px;
    left: 0;
    margin: 0 auto;
    position: absolute;
    right: 0;
    transition: transform 0.2s ease;
    width: fit-content;
    z-index: 2;

    @media (min-width: ${breakpoints._1170}) {
      display: none;
    }
  `,
  withOffset: css`
    @media (max-width: ${breakpoints._768}) {
      transform: translateY(-64px);
    }
  `
};
const dialogContentStyles = css`
  position: inherit;

  @media (min-width: ${breakpoints._768}) {
    position: sticky;
  }
`;
const CharacteristicItem = ({
  characteristic,
  isUnavailable,
  priceFrom
}) => {
  const {
    iconUrl,
    label,
    description,
    priceFromLabel
  } = useSeatCharacteristicDisplay(characteristic, isUnavailable);
  return /*#__PURE__*/_jsxs(Inline, {
    align: "start",
    className: wrapperStyles,
    children: [iconUrl && /*#__PURE__*/_jsx("img", {
      alt: "",
      className: iconStyles,
      src: iconUrl
    }), /*#__PURE__*/_jsxs(Stack, {
      className: priceDescriptionStyles,
      spacing: 4,
      children: [/*#__PURE__*/_jsx(Text, {
        variant: textVariants._14_BOLD,
        children: label
      }), !isUnavailable && priceFrom !== undefined && /*#__PURE__*/_jsxs(Text, {
        variant: textVariants._14,
        children: [priceFromLabel, ": ", priceUtil.formatPrice(priceFrom)]
      }), /*#__PURE__*/_jsx(Text, {
        variant: textVariants._14,
        children: description
      })]
    })]
  });
};
const SeatCharacteristicsToggleButton = ({
  seatCharacteristics,
  isSkipButtonShown
}) => {
  const {
    t
  } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const closeDialog = () => setIsOpen(false);
  const openDialog = () => setIsOpen(true);
  const closeButtonAriaLabel = t('ScreenReader.CloseButtonDialog.AriaLabel.Text');
  const seatingLegendButtonTitleLabel = t('Product.SeatMap.Characteristics.Label');
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(Button, {
      className: cx(buttonStyles.base, {
        [buttonStyles.withOffset]: isSkipButtonShown
      }),
      "data-testid": "seatMap-expandLegendButton",
      id: "seatMap-expandLegendButton",
      onClick: openDialog,
      type: "button",
      children: [/*#__PURE__*/_jsx(Info, {
        size: 20
      }), seatingLegendButtonTitleLabel]
    }), /*#__PURE__*/_jsx(Dialog, {
      className: dialogContentStyles,
      closeButtonAriaLabel: closeButtonAriaLabel,
      isOpen: isOpen,
      onDismiss: closeDialog,
      title: seatingLegendButtonTitleLabel,
      children: /*#__PURE__*/_jsxs(Stack, {
        align: "start",
        spacing: 16,
        children: [seatCharacteristics === null || seatCharacteristics === void 0 ? void 0 : seatCharacteristics.map(item => /*#__PURE__*/_jsx(CharacteristicItem, {
          characteristic: item.characteristic,
          priceFrom: item.price
        }, item.characteristic)), /*#__PURE__*/_jsx(CharacteristicItem, {
          isUnavailable: true
        })]
      })
    })]
  });
};
export default SeatCharacteristicsToggleButton;
//# sourceMappingURL=SeatCharacteristicsToggleButton.js.map